import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import { Icon } from 'react-icons-kit'
import { ic_add_box } from 'react-icons-kit/md/ic_add_box'
import { ic_search } from 'react-icons-kit/md/ic_search'
import { ic_delete } from 'react-icons-kit/md/ic_delete'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import NavBar from '../components/NavBar'
import FrTable from '../components/FrTable'
import FrTextInput from '../components/FrTextInput'
import FrSelect from '../components/FrSelect'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import FooterDelphus from '../components/FooterDelphus'
import AutoComp from '../components/AutoComp'
import FrDatePicker from '../components/FrDatePicker'


import api from '../services/api'
import { paramsToObject, formToObject, populateForm, objectToQueryString, isEmpty, getSedeCode } from '../utils/functions'

import './styles/DefaultMainScreen.css';
import './styles/Manut.css';

const swal = withReactContent(Swal)

function Contas_Receber(props) {
  const [data, setData] = useState([])
  const [filter, setFilter] = useState({})
  const [filtered, setFiltered] = useState(false)
  const [enableAdd, setenableAdd] = useState('N')
  const [enableEdit, setenableEdit] = useState('N')
  const [enableDel, setenableDel] = useState('N')
  const [comboCli, setComboCli] = useState([{ value: '', display: '' }])
  const [cli, setCli] = useState()
  const [selected, setSelected] = useState([])
  const [comboFpg, setComboFpg] = useState([{ value: '', display: '' }])
  const [comboAdesao, setComboAdesao] = useState([{ value: " and adesao_mensalidade='A'", display: 'Adesão' },
  { value: " and adesao_mensalidade='M'", display: 'Mensalidade' }
  ])
  const [somaCtr, setSomaCtr] = useState('')
  const [saldoCtr, setSaldoCtr] = useState('')
  const [pagoCtr, setPagoCtr] = useState('')

  const [comboSituacao, setComboSituacao] = useState([{ value: ' and data_pag is null', display: 'Pendentes' },
  { value: ' and data_pag is null and data_venc>=current_date', display: 'A Vencer' },
  { value: ' and data_pag is null and data_venc<current_date', display: 'Atrasados' }
  ])

  const columns = [
    { id: 'fk_cto', numeric: false, label: 'Nº Contrato', align: 'left', minWidth: 50 },
    { id: 'fk_cte', numeric: false, label: 'Nº Contrato Empresa', align: 'left', minWidth: 50 },
    { id: 'nomecli', numeric: false, label: 'Cliente/Empresa', align: 'left', minWidth: 200 },
    { id: 'data_venc', date: true, numeric: false, label: 'Data Vcto', align: 'left', minWidth: 50 },
    { id: 'data_pag', date: true, numeric: false, label: 'Data Pgto', align: 'left', minWidth: 50 },
    { id: 'format_valor', numeric: true, label: 'Valor', align: 'right', minWidth: 50 },
    { id: 'valor_pag', numeric: true, label: 'Valor Pago', align: 'right', minWidth: 50 },
    { id: 'valor_pend', numeric: true, label: 'Pendente', align: 'right', minWidth: 50 },
    { id: 'format_valor_baixado', numeric: true, label: 'Valor Baixado', align: 'right', minWidth: 50 },

  ]

  useEffect(() => {
    const fetchData = async () => {
      swal.fire({
        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })

      let tela = 'Contas a Receber'
      setenableAdd(await api.getAcessos(tela, 'Inclusao'))
      setenableEdit(await api.getAcessos(tela, 'Alteracao'))
      setenableDel(await api.getAcessos(tela, 'Exclusao'))

      setComboFpg(await api.getComboData('formas_pagamento'))


      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)
      if (query.fk_cli)
        setCli(query.fk_cli)

      setFilter(query)
      populateForm(document.getElementById('searchForm'), query)

      swal.close()
      if (query.buscar === 'true') {
        let event = new Event('build');
        getData(event)
      }
    }

    fetchData()
  }, [])

  function getData(e) {
    e.preventDefault()
    var formData = new FormData(document.getElementById('searchForm'))
    var queryObject = formToObject(formData)
    if (!isEmpty(queryObject)) {
      queryObject.buscar = true
      queryObject.pk_sed = getSedeCode()
      setFiltered(true)
      window.history.replaceState({ filtered: true }, 'filter', "/salute/contas_receber?" + objectToQueryString(queryObject));
      swal.fire({
        html: <FrLoading text="Buscando dados..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      api.get('/contas_receber', { params: queryObject }).then(r => {
        if (r.data[0]) {
          setSomaCtr(r.data[0].somaCtr)
          setSaldoCtr(r.data[0].saldoCtr)
          setPagoCtr(r.data[0].pagoCtr)
        } else {
          setSomaCtr('')
          setSaldoCtr('')
          setPagoCtr('')
        }
        setData(r.data)
        swal.close()
      })
    } else {
      swal.fire({
        title: 'Nenhum filtro informado!',
        html: '<p>Informe ao menos um filtro para realizar a busca.',
        icon: 'warning'
      })

    }
  }

  function clearForm(e) {
    e.preventDefault();
    window.history.replaceState({ filtered: false }, 'filter', '/salute/contas_receber');
    document.getElementById('searchForm').reset()
    setCli('')
    setFilter({})
  }

  const handleChange = (e) => {
    const auxValues = { ...filter };
    switch (e.target.name) {
      case 'fk_cli':
        setCli(e.target.value);
      default:
        auxValues[e.target.name] = e.target.value;
    }
    setFilter(auxValues);
  };


  useEffect(() => {
    const fetchCli = async () => {
      const auxValues = { ...filter };
      auxValues["fk_cli"] = cli;
      auxValues["nomecli"] = ''
      if (cli > 0) {
        await api.get("/clientes?pk_cli=" + cli).then((r) => {
          if (r.data[0]) {
            auxValues["nomecli"] = r.data[0].nome;

          }
        });
      }
      setFilter(auxValues);
    };
    fetchCli();
  }, [cli]);

  function liquidaLote(e) {
    e.preventDefault()
    console.log(selected)
    let cto
    let cli
    const selectedData = data.filter(item => selected.includes(item.pk_ctr))
    const filteredPaidRegisters = selectedData.filter(item => item.data_pag)
    let mesmoCtoCli = true
    console.log(selectedData)
    selectedData.forEach((item, index) => {
      console.log('oi', cto, cli)
      if (index > 0 && (cto !== item.fk_cto || cli !== item.fk_cli)) {
        mesmoCtoCli = false
      }

      cto = item.fk_cto
      cli = item.fk_cli
    })

    if (filteredPaidRegisters.length > 0 || selected.length == 0){
      return swal.fire('Registros já liquidados.', 'Selecione apenas registros que ainda nao foram liquidados.', 'error')
    }

    if (!mesmoCtoCli) {
      return swal.fire('Erro', 'Selecione apenas registros do mesmo contrato e cliente.', 'error')
    }
    console.log(mesmoCtoCli)

    window.location.href = "/salute/contas_receber/baixa?codigo=[" +selected+']&pix=true'

  }


  return (
    <div className="Manut">
      <NavBar />
      <div className="ManutContent">
        <div className="defaultHeader">
          <h3>Contas a Receber</h3>
          <UserOptions temaEscuro={props.temaEscuro} setTemaEscuro={props.setTemaEscuro} />
        </div>
        <br />
        <div className="filtersDiv">
          <form id="searchForm" onSubmit={getData}>
            <div>
              <AutoComp
                value={filter.nomecli || ""}
                valor={cli}
                width={400}
                tabela={'clientes'}
                chave={'nome'}
                name="fk_cli"
                id="fk_cli"
                label='Cliente'
                data={comboCli}
                setValue={setCli}
                form={'searchForm'}
                manut={'contas_receber'}
                autoFocus
              />

              <FrTextInput
                value={filter.pk_cto || ''}
                style={{ width: 100 }}
                name="pk_cto"
                id="pk_cto"
                color="#333333"
                label="Nº Contrato"
                variant="outlined"
                size="small"
                onChange={handleChange}
              />

              <FrSelect
                value={filter.adesao_mensalidade || -1}
                style={{ width: 150 }}
                name="adesao_mensalidade"
                id="adesao_mensalidade"
                label='Tipo'
                data={comboAdesao}
                onChange={handleChange}
                mostraTodos
              />

              <FrTextInput
                value={filter.num_guia || ''}
                style={{ width: 100 }}
                name="num_guia"
                id="num_guia"
                color="#333333"
                label="Nº Guia"
                variant="outlined"
                size="small"
                onChange={handleChange}
              />

              <FrSelect
                value={filter.fk_fpg || -1}
                style={{ width: 150 }}
                name="fk_fpg"
                id="fk_fpg"
                label='Forma de Pagamento'
                data={comboFpg}
                onChange={handleChange}
                mostraTodos
              />
              <br />
              <FrDatePicker
                value={(filter.datainivenc || '').split('T')[0]}
                name="datainivenc"
                id="datainivenc"
                color="#49573B"
                label="Período Vencimento"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
              />

              <label style={{ paddingRight: '7px', paddingTop: '7px' }}>a</label>

              <FrDatePicker
                value={(filter.datafimvenc || '').split('T')[0]}
                name="datafimvenc"
                id="datafimvenc"
                color="#49573B"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
              />

              <FrDatePicker
                value={(filter.datainiliq || '').split('T')[0]}
                name="datainiliq"
                id="datainiliq"
                color="#49573B"
                label="Período Pagamento"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
              />

              <label style={{ paddingRight: '7px', paddingTop: '7px' }}>a</label>

              <FrDatePicker
                value={(filter.datafimliq || '').split('T')[0]}
                name="datafimliq"
                id="datafimliq"
                color="#49573B"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
              />

              <FrSelect
                value={filter.situacao || -1}
                style={{ width: 150 }}
                name="situacao"
                id="situacao"
                label='Situação'
                data={comboSituacao}
                onChange={handleChange}
                mostraTodos
              />

            </div>
            <div>
              <button onClick={getData}>
                <Icon icon={ic_search} size={18} />
                Pesquisar
              </button>
              <button onClick={clearForm}>
                <Icon icon={ic_delete} size={18} />
                Limpar
              </button>
              <button onClick={liquidaLote}>
                <Icon icon={ic_delete} size={18} />
                Liquidar em Lote
              </button>
              {enableAdd !== 'S' ? '' :
                <Link to="/salute/contas_receber/registro">
                  <button >
                    <Icon icon={ic_add_box} size={18} />
                    Novo Registro
                  </button>
                </Link>}


              <label hidden={!somaCtr} style={{ paddingLeft: '10px' }}>Total Valor:</label>
              <label hidden={!somaCtr} style={{ paddingLeft: '10px', fontWeight: 'bold', fontSize: 'large' }}> {somaCtr}</label>
              <label hidden={!pagoCtr} style={{ paddingLeft: '10px' }}>Total Pago:</label>
              <label hidden={!pagoCtr} style={{ paddingLeft: '10px', fontWeight: 'bold', fontSize: 'large' }}>{pagoCtr}</label>
              <label hidden={!saldoCtr} style={{ paddingLeft: '10px' }}>Total Pendente:</label>
              <label hidden={!saldoCtr} style={{ paddingLeft: '10px', fontWeight: 'bold', fontSize: 'large' }}>{saldoCtr}</label>

            </div>
          </form>
        </div>
        <br />
        <div className={"tableDiv" + (props.frame && data.length > 0 ? '-frame' : '')}>
          <FrTable 
            startOrderBy={'data_venc'} 
            mostraCheck={'S'} 
            width={150} 
            regName="contas_receber" 
            frame={props.frame} 
            columns={columns} 
            searched={filtered} 
            codeName="pk_ctr" 
            page={'contas_receber'} 
            data={data} 
            enableEdit={enableEdit} 
            enableDel={enableDel} 
            selected={selected}
            setSelected={setSelected}
            baixaCtr
            baixaPix
          />


        </div>
        <FooterDelphus />
      </div>
    </div>
  );
}

export default Contas_Receber;